export enum INTEGRATION_CODE {
    GORGIAS = 'gorgias',
    GORGIAS_APP = 'gorgias-app',
    DELIVERR = 'deliverr',
    SHIPBOB = 'shipbob',
    ZENDESK = 'zendesk',
    ZENDESK_OAUTH = 'zendesk-oauth',
    SHIPEDGE = 'shipedge',
    REFUNDID = 'refundid',
    REVENI = 'reveni',
    NET_SUITE = 'netsuite',
    PICQER = 'picqer',
    TRENGO = 'trengo',
    SHIPHERO = 'shiphero',
    PEOPLEVOX = 'peoplevox',
    KLAVIYO = 'klaviyo',
    REAMAZE = 'reamaze',
    RISE = 'rise',
    BRIGHTPEARL = 'brightpearl',
    FRESHDESK = 'freshdesk',
    MINTSOFT = 'mintsoft',
    AMAZON_MCF = 'amazon-mcf',
    CIN7 = 'cin7',
    AIMS = 'aims',
    RLM = 'rlm',
    STRIPE = 'stripe',
    BERGEN = 'bergen-logistics',
    WHIPLASH = 'whiplash',
    APPAREL21 = 'apparel21',
    YOTPO = 'yotpo',
    SHIPMONK = 'shipmonk',
    DEPOSCO = 'deposco',
    TRACKSTAR = 'trackstar',
    ADYEN = 'adyen',
    ADYEN_BASIC = 'adyen-basic',
    BRAINTREE = 'braintree',
    CUSTOM_DYNAMIC_LOCATION = 'custom-dynamic-location',
    CYBERSOURCE = 'cybersource',
    GLOBAL_E_REFUND = 'global-e-refund',
};

export enum SHIPPING_CONNECTION_CODE {
    SHIP_STATION = 'shipstation',
    SHIPPO = 'shippo',
    USPS = 'usps-direct',
    SENDCLOUD = 'sendcloud',
    CANADA_POST = 'canadapost',
    AUSTRALIA_POST = 'australiapost',
    EASY_POST = 'easypost',
    SHIPMONDO = 'shipmondo',
    STARSHIPIT = 'starshipit',
    NZ_POST_ESHIP = 'nzpost-eship',
    SALASA = 'salasa',
    SHIPPY_PRO = 'shippypro',
    CARGO = 'cargo',
    HAPPY_RETURNS = 'happy-returns',
    SEKO = 'seko',
    PARCEL_NINJA = 'parcel-ninja',
    DHL_EXPRESS = 'dhl',
    WEBSHIPPER = 'webshipper',
    INTERSOFT = 'intersoft',
    FEDEX = 'fedex',
    MONDIAL_RELAY = 'mondial-relay',
    REBOUND = 'rebound',
    CORREOS = 'correos',
    INPOST_UK = 'inpost-uk',
    SENDCLOUD_RETURNS = 'sendcloud-returns',
    VESYL = 'vesyl',
    THE_RETURN = 'the-return',
    ENVOI_DU_NET = 'envoi-du-net',
    LABELGO = 'labelgo-spl',
    YODEL = 'yodel',
    DHL_DE_RETURNS = 'dhl-de-returns',
    EASYSHIP = 'labelgo-easyship',
    K_EXPRESS = 'k-express',
    ZIGZAG = 'zig-zag',
    RETURN_GUARD = 'return-guard',
    SHIP_BY_RGO = 'ship-by-returngo',
    RGO_SENDCLOUD_RETURNS = 'rgo-sendcloud-returns',
    SHIPSTATION_V2 = 'shipstation-v2',
    RGO_MULTI_ADAPTER = 'rgo-multi-adapter',
    GLOBAL_E = 'global-e',
    DPD_UK = 'dpd-uk',
};

export const INTEGRATION_NAME_MAP: {[key: string]: {name: string}} = {
    [INTEGRATION_CODE.GORGIAS]: { name: 'Gorgias' },
    [INTEGRATION_CODE.GORGIAS_APP]: { name: 'Gorgias App' },
    [INTEGRATION_CODE.DELIVERR]: { name: 'Deliverr' },
    [INTEGRATION_CODE.SHIPBOB]: { name: 'Shipbob' },
    [INTEGRATION_CODE.ZENDESK]: { name: 'Zendesk' },
    [INTEGRATION_CODE.ZENDESK_OAUTH]: { name: 'Zendesk-OAuth' },
    [INTEGRATION_CODE.SHIPEDGE]: { name: 'Shipedge' },
    [INTEGRATION_CODE.REFUNDID]: { name: 'Refundid' },
    [INTEGRATION_CODE.REVENI]: { name: 'Reveni' },
    [INTEGRATION_CODE.NET_SUITE]: { name: 'Netsuite' },
    [INTEGRATION_CODE.PICQER]: { name: 'Picqer' },
    [INTEGRATION_CODE.TRENGO]: { name: 'Trengo' },
    [INTEGRATION_CODE.SHIPHERO]: { name: 'Shiphero' },
    [INTEGRATION_CODE.PEOPLEVOX]: { name: 'Peoplevox' },
    [INTEGRATION_CODE.KLAVIYO]: { name: 'Klaviyo' },
    [INTEGRATION_CODE.REAMAZE]: { name: 'Reamaze' },
    [INTEGRATION_CODE.RISE]: { name: 'Rise' },
    [INTEGRATION_CODE.BRIGHTPEARL]: { name: 'Brightpearl' },
    [INTEGRATION_CODE.FRESHDESK]: { name: 'Freshdesk' },
    [INTEGRATION_CODE.MINTSOFT]: { name: 'Mintsoft' },
    [INTEGRATION_CODE.AMAZON_MCF]: { name: 'Amazon MCF' },
    [INTEGRATION_CODE.CIN7]: { name: 'Cin7' },
    [INTEGRATION_CODE.AIMS]: { name: 'Aims' },
    [INTEGRATION_CODE.RLM]: { name: 'RLM' },
    [INTEGRATION_CODE.STRIPE]: { name: 'Stripe' },
    [INTEGRATION_CODE.BERGEN]: { name: 'Bergen Logistics' },
    [INTEGRATION_CODE.YOTPO]: { name: 'Yotpo' },
    [INTEGRATION_CODE.SHIPMONK]: { name: 'Shipmonk' },
    [INTEGRATION_CODE.ADYEN]: { name: 'Adyen' },
    [INTEGRATION_CODE.ADYEN_BASIC]: { name: 'Adyen Basic' },
    [INTEGRATION_CODE.BRAINTREE]: { name: 'Braintree' },
    [INTEGRATION_CODE.CUSTOM_DYNAMIC_LOCATION]: { name: 'Custom dynamic location' },
    [INTEGRATION_CODE.CYBERSOURCE]: { name: 'Cybersource' },
    [INTEGRATION_CODE.GLOBAL_E_REFUND]: { name: 'Global-E Refund' },
    [SHIPPING_CONNECTION_CODE.SHIP_STATION]: { name: 'Shipstation' },
    [SHIPPING_CONNECTION_CODE.SHIPPO]: { name: 'Shippo' },
    [SHIPPING_CONNECTION_CODE.USPS]: { name: 'USPS' },
    [SHIPPING_CONNECTION_CODE.SENDCLOUD]: { name: 'Sendcloud' },
    [SHIPPING_CONNECTION_CODE.CANADA_POST]: { name: 'Canadapost' },
    [SHIPPING_CONNECTION_CODE.AUSTRALIA_POST]: { name: 'Australiapost' },
    [SHIPPING_CONNECTION_CODE.EASY_POST]: { name: 'Easypost' },
    [SHIPPING_CONNECTION_CODE.SHIPMONDO]: { name: 'Shipmondo' },
    [SHIPPING_CONNECTION_CODE.STARSHIPIT]: { name: 'Starshipit' },
    [SHIPPING_CONNECTION_CODE.NZ_POST_ESHIP]: { name: 'NZ Post' },
    [SHIPPING_CONNECTION_CODE.SALASA]: { name: 'Salasa' },
    [SHIPPING_CONNECTION_CODE.SHIPPY_PRO]: { name: 'Shippypro' },
    [SHIPPING_CONNECTION_CODE.CARGO]: { name: 'Cargo' },
    [SHIPPING_CONNECTION_CODE.HAPPY_RETURNS]: { name: 'Happy Returns' },
    [SHIPPING_CONNECTION_CODE.SEKO]: { name: 'SEKO' },
    [SHIPPING_CONNECTION_CODE.PARCEL_NINJA]: { name: 'Parcelninja' },
    [SHIPPING_CONNECTION_CODE.DHL_EXPRESS]: { name: 'DHL' },
    [SHIPPING_CONNECTION_CODE.WEBSHIPPER]: { name: 'Webshipper' },
    [SHIPPING_CONNECTION_CODE.INTERSOFT]: { name: 'Royal Mail' },
    [SHIPPING_CONNECTION_CODE.FEDEX]: { name: 'FedEx' },
    [SHIPPING_CONNECTION_CODE.MONDIAL_RELAY]: { name: 'Mondial Relay' },
    [SHIPPING_CONNECTION_CODE.REBOUND]: { name: 'Rebound' },
    [SHIPPING_CONNECTION_CODE.CORREOS]: { name: 'Correos' },
    [SHIPPING_CONNECTION_CODE.INPOST_UK]: { name: 'InPost UK' },
    [SHIPPING_CONNECTION_CODE.SENDCLOUD_RETURNS]: { name: 'Sendcloud Returns (v3)' },
    [SHIPPING_CONNECTION_CODE.VESYL]: { name: 'Vesyl' },
    [SHIPPING_CONNECTION_CODE.THE_RETURN]: { name: 'The Return' },
    [SHIPPING_CONNECTION_CODE.ENVOI_DU_NET]: { name: 'Envoi du Net' },
    [SHIPPING_CONNECTION_CODE.LABELGO]: { name: 'LabelGO SPL' },
    [SHIPPING_CONNECTION_CODE.YODEL]: { name: 'Yodel' },
    [SHIPPING_CONNECTION_CODE.EASYSHIP]: { name: 'LabelGO by Easyship' },
    [SHIPPING_CONNECTION_CODE.ZIGZAG]: { name: 'ZigZag' },
    [SHIPPING_CONNECTION_CODE.SHIPSTATION_V2]: { name: 'Shipstation v2' },
    [SHIPPING_CONNECTION_CODE.GLOBAL_E]: { name: 'Global-E' },
    [SHIPPING_CONNECTION_CODE.DPD_UK]: { name: 'DPD UK' },
}

export enum INTEGRATION_CATEGORY {
    CUSTOMER_SUPPORT = 'customer-support',
    INVENTORY_TRACKING = 'inventory-tracking',
    INSTANT_REFUND = 'instant-refund',
    CUSTOMER_NOTIFICATIONS = 'customer-notifications',
};

export enum SHIPPING_INTEGRATION_CATEGORY {
    SHIPPING = 'shipping',
    DROP_OFF = 'drop-off'
}

export enum INTEGRATION_ACTION {
    CREATE_RMA = 'create-rma',
    RESTOCK_ITEMS = 'restock-items',
    INSTANT_REFUND = 'instant-refund',
    CREATE_TICKET = 'create-ticket',
    UPDATE_TICKET = 'update-ticket',
    STORE_NAME_INDICATION = 'store-name-indication',
    NOTIFY_REFUND = 'notify-refund',
    NOTIFY_EMAIL = 'notify-email',
}

/**
 * Seems like redundant
 */
export enum INTEGRATION_ACTION_STATUS {
    STATUS_ENABLED = 'enabled',
    STATUS_ENABLED_PLUS_SHOPIFY = 'enabled-plus-shopify',
    STATUS_ENABLED_ONLY_SHOPIFY = 'enabled-only-shopify',
    STATUS_ALL_RMAS = 'all-rmas',
    STATUS_ONLY_PENDING_RMAS = 'only-pending-rmas',
    STATUS_ONLY_ERROR = 'only-error',
    STATUS_ALL_UPDATES = 'all-updates',

}
export interface IShopifySettings {
    return_portal_path: string,
    tracking_portal_path: string,
    custom_return_portal_url: string,
    custom_tracking_portal_url: string,
    proxy_path: string,
    store_domain: string,
    is_integration_enabled: boolean,
    is_policies_enabled: boolean,
    auto_track_store_orders: boolean,
    use_custom_return_portal_url: boolean,
    use_custom_tracking_portal_url: boolean,
    use_shopify_returns_api: boolean,

    _auto_track_store_orders_changed?: boolean;
    _integration_enabled_changed?: boolean
};

export interface IIntegrationCategoryPreset {
    id: INTEGRATION_CATEGORY | SHIPPING_INTEGRATION_CATEGORY,
    label: string,
    is_allowed: boolean,
    integrations: IIntegrationPreset[],
};

export interface IActionValue {
    id: string,
    label: string,
    note?: string,
};

/** This interface corresponds to IntegrationConfigPresets action type */
export interface IAction {
    id: string,
    label: string,
    default: boolean | string,
    type: INTEGRATION_ACTION_INPUT_TYPE,
    values?: IActionValue[],
    is_hidden?: boolean,
    optional?: boolean,
    description?: string,
};

export enum INTEGRATION_ACTION_INPUT_TYPE {
    TOGGLE_INPUT = 'toggle-input',
    INPUT = 'input',
    DROPDOWN = 'dropdown',
    TOGGLE = 'toggle',
}

export interface IActionStoreValue {
    [key: string]: any,
};

export interface IIntegrationPreset {
    id: INTEGRATION_CODE | SHIPPING_CONNECTION_CODE,
    label: string,
    available_soon: boolean,
    description: string,
    is_allowed: boolean,
    actions: IAction[],
    credentials_params: IOAuthCredentialsParams,
    exclude_from_feature_category?: boolean,
    is_sandbox_mode_available?: boolean;
};

export interface IIntegartionSettings {
    action: INTEGRATION_ACTION,
    status?: string | boolean,
    created_at?: string,
    deleted_at?: string,
    id: number,
    integrations_connection_id: number,
    updated_at?: string,
    _has_changes?: boolean;
};

export interface IIntegration {
    created_at?: string,
    deleted_at?: string,
    id: number,
    service_code: INTEGRATION_CODE,
    internal_name: string,
    service_type: INTEGRATION_CATEGORY,
    is_enabled: boolean,
    token: string, /** TODO: remove from client and api response */
    updated_at?: string,
    user_id: number,
    _delete_info: IIntegrationDeleteInfo,
    integration_settings: IIntegartionSettings[],
    api_key?: IApiKey,
};

export interface IIntegrationDeleteInfo {
    can_be_deleted: boolean,
    message?: string
}

export interface IShippingConnection {
    created_at?: string,
    deleted_at?: string,
    internal_name: string,
    id: number,
    aggregator_code: SHIPPING_CONNECTION_CODE,
    token: string,
    updated_at?: string,
    user_id: number,
    _delete_info: IIntegrationDeleteInfo,
    test_mode: boolean,

};

export interface ISelectedIntegration {
    value: INTEGRATION_CODE | SHIPPING_CONNECTION_CODE,
    label: string,
    isDisabled: boolean,
    isAllowed: boolean,
    category: INTEGRATION_CATEGORY | SHIPPING_INTEGRATION_CATEGORY,
};

export interface IOAuthCredentialsParams {
    oauth_url: string;
    dynamic_link?: boolean;
    state?: string;
    code_verification?: {
        code_verifier?: string;
        code_challenge?: string;
        code_challenge_method?: string;
    };
    callback_url?: string;
    nonce?: string;
    account_id?: string;
    client_id?: string;
    customer_id?: string;
    warehouse_id?: string;
    is_sandbox?: boolean;
};

export interface AccountLinkResponseDto {
	authLink: string;
	accountId?: string;
    state?: string;
}

export interface ICreateCheckoutSessionResponseDto {
    url: string;
    checkoutSessionId: string;
    customerId: string;
    isSandbox: boolean;
}

interface ICardPaymentMethodDto {
    brand: string;
    last4: string;
    expiration: {
        month: number;
        year: number;
    }
}

export interface IConfirmCheckoutSessionRequestDto {
    card: ICardPaymentMethodDto;
}

export interface IApiKey {
    api_key: string;
    created_at: string;
    deleted_at?: string;
    id: number;
    integrations_connection_id: number;
    name: string;
    updated_at?: string;
};

export interface IApiKeyCredentialsModel {
    api_key: string;
    internal_name: string;
}

export interface IApiSecertCredentialsModel extends IApiKeyCredentialsModel {
    api_secret: string;
}

export interface ICustomerNumberCredentialsModel extends IApiSecertCredentialsModel {
    customer_number: string;
}

export interface IIntersoftCredentialsModel extends IApiKeyCredentialsModel {
    customer_number: string;
    email_address: string;
}

export interface IWebshipperCredentialsModel extends IApiKeyCredentialsModel {
    username: string;
    order_channel_id: string;
}

export interface IFedexCredentialsModel extends IApiKeyCredentialsModel {
    webservice_client_id?: string;
    webservice_client_secret?: string;
}

export interface IMondialRelayCredentialsModel extends ICustomerNumberCredentialsModel {
    username: string;
    order_channel_id: string;
}

export interface IReboundCredentialsModel extends IApiSecertCredentialsModel {
    email_address: string;
    parcel_type: string;
    warehouse: string;
    username: string;
    order_channel_id: string;
    frontend: string;
}

export interface IDhlCredentialsModel extends ICustomerNumberCredentialsModel {
    vat_number: string;
    eori_number: string;
    duties_taxes_account_number: string;
};

export interface ISendcloudReturnsCredentialsModel extends IApiSecertCredentialsModel {
    brand_id: string;
}

export interface IShipmonkCredentialsModel extends IApiKeyCredentialsModel {
    store_id: string;
    warehouse: string;
}

export interface IEnvoiDuNetCredentialsModel {
    api_username: string;
    api_password: string;
    site_id: string;
    base_api_url: string;
    tms_api_key: string;
    tms_api_account: string;
    internal_name: string;
}

export interface ILabelGOCredentialsModel {
    username: string;
    password: string;
    account_number: string;
    base_api_url: string;
}

export interface IYodelCredentialsModel {
    api_key: string;
    client_id: string;
    client_secret: string;
    account_number: string;
}

export interface ISalasaCredentialsModel {
    api_key: string;
    api_token: string;
    warehouse: string;
    account_id: string;
}

export interface IDhlDeReturnsCredentialsModel {
    username: string;
    password: string;
}

export interface IEasyshipCredentialsModel {
    api_key: string;
}

export interface IDeliverrCredentialsModel {
    api_token: string;
}

export interface IKExpressCredentialsModel {
    api_token: string;
    customer_id: string;
}

export interface IZigZagCredentialsModel {
    username: string;
    password: string;
    account_number: string;
}

export interface IBraintreeCredentialsModel {
    public_key: string;
    private_key: string;
}

export enum STRIPE_ERROR{
    ACTIVATE_ACCOUNT = 'Activate account',
}

export interface IGlobalECredentialsModel {
    base_api_url: string;
    api_username: string;
}
export interface IDpdUkCredentialsModel {
    username: string;
    password: string;
    account_number: string;
    tax_number?: string;
    eori_number?: string;
    pid_number?: string;
}
